export default __webpack_public_path__ + "static/salehIbrahim-c34bef2d871230ca3d0fcebbdab30ef6.jpg";